import { render, staticRenderFns } from "./St21Cn2061ReportDate.vue?vue&type=template&id=2fe2b95e&scoped=true&"
import script from "./St21Cn2061ReportDate.vue?vue&type=script&lang=js&"
export * from "./St21Cn2061ReportDate.vue?vue&type=script&lang=js&"
import style0 from "./St21Cn2061ReportDate.vue?vue&type=style&index=0&id=2fe2b95e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe2b95e",
  null
  
)

export default component.exports